
import Bag2 from "../../../assets/duotone/Bag2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Bag2Icon({ className, dataTestid = "Bag2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bag2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
